import React, { useEffect, useState } from "react";
import server from "../../../server";
import { ILeaveRequestData, LeavePeriod } from "./types/leave-graph-types";
import LeaveRequestAnalysisChart from "./leave-request-analysis-chart";
import StatsChart from "../../common/stats-chart/stats-chart";
import { BarChart2 } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const LeaveRequestSummary = () => {
    const [leaveRequestData, setLeaveRequestData] = useState<ILeaveRequestData>();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


    const handleOnClick = () => {
        navigate('/time-off/leaves/approvals')
    }


    useEffect(() => {
        fetchLeavePeriod();
    }, []);

    async function fetchLeavePeriod() {
        try {
            const leavePeriods: LeavePeriod[] = await server.leave.period.list();
            const today = new Date();
            const currentLeavePeriod = leavePeriods.find((period) => {
                const start = new Date(period.startDate);
                const end = new Date(period.endDate);
                return today >= start && today <= end;
            });

            if (currentLeavePeriod) {
                fetchLeaveRequestsData(currentLeavePeriod.id);
            }

        } catch (e) {
            console.log("Error while fetching leave period", e);
        }
    }

    async function fetchLeaveRequestsData(leavePeriodId: string) {
        setLoading(true);
        try {
            const leaveRequests = await server.leave.leaveSummary.list(leavePeriodId);
            setLeaveRequestData(leaveRequests);
        } catch (e) {
            console.log("Error while fetching leave request data", e);
        } finally {
            setLoading(false)
        }
    }

    return (
        <StatsChart
            icon={BarChart2}
            title="Leave Request Analysis"
            badge={{
                text: `${leaveRequestData?.totalRequest ? `${leaveRequestData.totalRequest} Leave Requests ` : ""} `,
                color: "purple"
            }}
            onClick={handleOnClick}
            subtitle={'This year\'s leave overview.'}
            className={'dashboard-leave-card'}
        >
            <LeaveRequestAnalysisChart leaveRequestData={leaveRequestData} loading={loading}/>
        </StatsChart>

    );
}

export default LeaveRequestSummary;
